module.exports = __webpack_public_path__ + "images/2-big.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/2-big.png
 ** module id = 571
 ** module chunks = 0
 **/